import React from "react"
import { CircularProgress, Toggle } from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import EquipmentStore from "../../stores/EquipmentStore"
import EquipmentTimecardActionBar from "./EquipmentTimecardActionBar"
import AddPunchDialogForEquipment from "../punch/AddPunchDialogForEquipment"
import EquipmentTimecardWeekTable from "./EquipmentTimecardWeekTable"
import AccountStore from "../../stores/AccountStore"
import TimecardDailyDrawer from "./daily_drawer/TimecardDailyDrawer"
import moment from "moment"
import * as equipmentActions from "../../actions/EquipmentActions"
import * as punchActions from "../../actions/PunchActions"
import { IDate, IObjectTimecardDocument, ITimecardDay, IPunchBundle, ECheckResultForRemovedPunchData } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import * as punchHelper from "../../helpers/punchHelper"
import * as timecardHelper from "../../helpers/timecardHelper"
import UserLock from "../../../assets/icons/user-lock"
import PendingTimecardUI from "../timecard_sequence/PendingTimecardUI"
import { grey400 } from "material-ui/styles/colors"
import * as api from "../../api"
import HierarchyJobTimezoneStr from "../common/HierarchyJobTimezoneStr"

interface IProps {
    equipmentId: string
    readonly: boolean
}
interface IState {
    referenceDate: IDate
    pending: boolean
    pendingReviewed: boolean
    timecard: IObjectTimecardDocument
    loadingTimecards: boolean
    openAddPunchDialog: boolean
    punchTimecardDay: ITimecardDay
    showComponentTimecards: boolean
    isPunchIn: boolean
    pairedPunchId: string
    dailyDrawerDate: number
    defaultAddPunchHierarchyId?: string
    defaultShiftId?: string
    defaultAddJobId?: string
    defaultAddPhaseId?: string
    defaultAddPunchPositionId?: string
    defaultAddPayClassId?: string
    defaultAddPunchPayTypeId?: string
    defaultEmployeeId?: string
}
export default class EquipmentTimecard extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            referenceDate: moment().format(),
            pending: false,
            pendingReviewed: false,
            timecard: null,
            loadingTimecards: true,
            openAddPunchDialog: false,
            punchTimecardDay: null,
            showComponentTimecards: false,
            isPunchIn: true,
            pairedPunchId: null,
            dailyDrawerDate: null,
        }
        autobind(this)
    }

    componentDidMount() {
        this.loadTimecard()
        EquipmentStore.on("change", this.changeSelectedEquipmentTimecard)
        AccountStore.on("account_change", this.changeAccount)
    }

    componentWillReceiveProps(nextProps: IProps) {
        (this.props.equipmentId !== nextProps.equipmentId || this.props.readonly !== nextProps.readonly) &&
            this.loadTimecard()
    }

    componentWillUnmount() {
        EquipmentStore.removeListener("change", this.changeSelectedEquipmentTimecard)
        AccountStore.removeListener("account_change", this.changeAccount)
    }

    changeAccount() {
        this.forceUpdate()
    }

    changeSelectedEquipmentTimecard() {
        const pending = EquipmentStore.getSelectedEquipmentTimecardPending()
        const timecard = EquipmentStore.getSelectedEquipmentTimecard()
        this.setState({
            pending,
            timecard,
            loadingTimecards: false,
            showComponentTimecards: !pending && timecard.ComponentTimecards && timecard.ComponentTimecards.length > 1 ?
                this.state.showComponentTimecards :
                false,
        })

        AppStateStore.getTextProgressSnackbarContent() !== null &&
            AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.getProgressSnackbarContent() === "loading" &&
            AppStateStore.setProgressSnackbarContent(null)
        EquipmentStore.getSelectedEquipmentTimecardPending() &&
            AppStateStore.setAlertDialogContent({
                buttonTitle: strings.Close,
                title: strings.Timecard_Change_Already_In_Process,
                content: strings.Cannot_generate_timecard,
                icon: <UserLock width={100} height={80} color={grey400} />,
                handleCloseCallBack: () => this.setState({ pendingReviewed: true })
            })
    }

    loadTimecard(msg?: string) {
        equipmentActions.getEquipmentTimecard(this.props.equipmentId, moment(this.state.referenceDate).utc(true).format(), msg)
    }

    addPunch(userId: string, punchBundle: IPunchBundle) {
        this.closeAddPunchDialog()
        punchActions.addPunch(userId, punchBundle, !this.state.isPunchIn, (msg) => this.loadTimecard(msg))
    }

    async addPunchToTimecardDay(timecardDay, hierarchyItemId, positionId, payClassId, payTypeId, employeeId, shiftId, jobId, phaseId, isPunchIn, pairedPunchId) {
        const result = await punchHelper.checkRemovedDataForPunch(employeeId, hierarchyItemId, shiftId, jobId, phaseId, positionId)
        if (result !== ECheckResultForRemovedPunchData.Valid) return
        for (let i = 0; i < this.state.timecard.MasterTimecard.TimecardWeeks.length; i++) {
            for (let j = 0; j < this.state.timecard.MasterTimecard.TimecardWeeks[i].Days.length; j++) {
                if (
                    timecardDay.StartDayTime === this.state.timecard.MasterTimecard.TimecardWeeks[i].Days[j].StartDayTime &&
                    timecardDay.EndDayTime === this.state.timecard.MasterTimecard.TimecardWeeks[i].Days[j].EndDayTime
                ) {
                    this.setState({
                        punchTimecardDay: this.state.timecard.MasterTimecard.TimecardWeeks[i].Days[j],
                        defaultAddPunchHierarchyId: hierarchyItemId,
                        defaultAddPunchPositionId: positionId,
                        defaultAddPayClassId: payClassId,
                        defaultAddPunchPayTypeId: payTypeId,
                        defaultEmployeeId: employeeId,
                        defaultShiftId: shiftId,
                        defaultAddJobId: jobId,
                        defaultAddPhaseId: phaseId,
                        isPunchIn,
                        pairedPunchId,
                        openAddPunchDialog: true
                    })
                    break
                }
            }
        }
    }

    onTimeChange(punchId, dateTime, errorCb: () => void) {
        const punch = {
            DateTime: moment(dateTime).utc().format()
        }
        // userId is null, it's not problem, because UserId is used to check IsESSAction or not, and not passed to endpoint
        punchActions.patchPunch(null, punchId, punch, false, null, false, (msg) =>
            this.setState({ loadingTimecards: true }, () =>
                this.setState({ loadingTimecards: false }, () =>
                    this.loadTimecard(msg)
                )
            ),
            errorCb
        )
    }

    onConfirmDelete(deletePunchId) {
        punchActions.deletePunchHandler(
            deletePunchId,
            this.state.timecard.MasterTimecard.FullPunchSets.find(ps => ps.PunchInId === deletePunchId || ps.PunchOutId === deletePunchId),
            false,
            (msg) => this.loadTimecard(msg)
        )
    }

    closeAddPunchDialog() {
        this.setState({ openAddPunchDialog: false })
    }

    getRefreshXPosition() {
        return window.innerWidth / 2.5
    }

    onShowComponentTimecardsToggle() {
        this.setState({ showComponentTimecards: !this.state.showComponentTimecards })
    }

    openDailyHistoryDrawer(date) {
        this.setState({ dailyDrawerDate: date })
    }

    closeDailyHistoryDrawer() {
        this.setState({ dailyDrawerDate: null })
    }

    render() {
        let timecardUI = (
            <div style={{ textAlign: "center" }}>
                <CircularProgress />
            </div>
        )

        if (!this.state.loadingTimecards) {
            if (this.state.pending) {
                timecardUI = (
                    <PendingTimecardUI
                        pendingReviewed={this.state.pendingReviewed}
                        handleGenerateTimecard={async () => {
                            this.setState({ pendingReviewed: false })
                            await api.generateEquipmentTimecard(this.props.equipmentId)
                            this.loadTimecard()
                        }}
                    />
                )
            }
            else {
                let masterTimezoneLabel
                let componentTimecardToggle

                if (this.state.timecard.ComponentTimecards && this.state.timecard.ComponentTimecards.length > 1) {
                    componentTimecardToggle = (
                        <div>
                            <div style={{ maxWidth: 250, float: "right", margin: 10 }}>
                                <Toggle label={strings.ShowComponentTimecards} onToggle={this.onShowComponentTimecardsToggle} toggled={this.state.showComponentTimecards} />
                            </div>
                            <div style={{ clear: "both" }} />
                        </div>
                    )
                } else {
                    if (this.state.timecard.ComponentTimecards && this.state.timecard.ComponentTimecards.length > 0) {
                        let componentTimecard = this.state.timecard.ComponentTimecards[0]
                        masterTimezoneLabel = (
                            <div style={{ float: "right", marginRight: 10 }}>
                                <i>
                                    {strings.Hierarchy_Timezone}:&nbsp;
                                    <HierarchyJobTimezoneStr
                                        hierarchyId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
                                        jobId={componentTimecard.JobId}
                                        utcTime={this.state.timecard.StartDateUTC}
                                    />
                                </i>
                            </div>);
                    }
                }

                if (this.state.showComponentTimecards) {
                    timecardUI = (
                        <div>
                            {componentTimecardToggle}
                            {this.state.timecard.ComponentTimecards.map((componentTimecard, i) => {
                                const account = AccountStore.getCurrentAccount()
                                let timecardLabel = account.Name
                                if (componentTimecard.HierarchyItem) {
                                    timecardLabel = componentTimecard.HierarchyItem.Label
                                }

                                if (componentTimecard.Position) {
                                    timecardLabel += ": "
                                }

                                let jobPhaseLabel
                                if (componentTimecard.JobId) {
                                    jobPhaseLabel = ` ${strings.Job}: ${componentTimecard.JobName}`
                                }
                                if (componentTimecard.JobId && componentTimecard.PhaseId) {
                                    jobPhaseLabel += ` ${strings.Phase}: ${componentTimecard.PhaseName}`
                                }
                                return (
                                    <div
                                        style={{
                                            borderTop: "solid 1px #efefef",
                                            paddingTop: 10
                                        }}
                                        key={i}
                                    >
                                        <b>{timecardLabel}</b>
                                        {timecardHelper.getTimecardPositionLabel(componentTimecard)}
                                        {jobPhaseLabel}
                                        <div style={{ float: "right" }}>
                                            <i>
                                                {strings.Hierarchy_Timezone}:&nbsp;
                                                <HierarchyJobTimezoneStr
                                                    hierarchyId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
                                                    jobId={componentTimecard.JobId}
                                                    utcTime={this.state.timecard.StartDateUTC}
                                                />
                                            </i>
                                        </div>
                                        {componentTimecard.TimecardWeeks.map((timecardWeek, i) => {
                                            return (
                                                <EquipmentTimecardWeekTable
                                                    fullPunchSes={this.state.timecard.MasterTimecard.FullPunchSets}
                                                    timecardWeek={timecardWeek}
                                                    onAddPunchToTimecardDay={this.addPunchToTimecardDay}
                                                    onTimeChange={this.onTimeChange}
                                                    onConfirmDelete={this.onConfirmDelete}
                                                    readonly={this.props.readonly}
                                                    key={i}
                                                    hierarchyItemId={componentTimecard.HierarchyItem ? componentTimecard.HierarchyItem.Id : null}
                                                    positionId={componentTimecard.Position ? componentTimecard.Position.Id : null}
                                                    openDailyHistoryDrawer={this.openDailyHistoryDrawer}
                                                    reloadTimecard={this.loadTimecard}
                                                />
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </div>
                    )
                } else {
                    let timecardLabel = ""
                    let positionLabel = ""
                    let labelPadding
                    if (this.state.timecard.ComponentTimecards && this.state.timecard.ComponentTimecards.length === 1) {
                        const componentTimecard = this.state.timecard.ComponentTimecards[0]
                        timecardLabel = AccountStore.getCurrentAccount() ? AccountStore.getCurrentAccount().Name : ""
                        labelPadding = <div style={{ marginTop: 20 }} />

                        if (componentTimecard.HierarchyItem) {
                            timecardLabel = componentTimecard.HierarchyItem.Label
                        }

                        if (componentTimecard.Position) {
                            timecardLabel += ": "
                        }
                        positionLabel = timecardHelper.getTimecardPositionLabel(componentTimecard)
                    }


                    timecardUI = (
                        <div>
                            {componentTimecardToggle}
                            {labelPadding}
                            <b>{timecardLabel}</b> {positionLabel}
                            {masterTimezoneLabel}
                            <EquipmentTimecardWeekTable
                                fullPunchSes={this.state.timecard.MasterTimecard.FullPunchSets}
                                timecardWeek={this.state.timecard.MasterTimecard.TimecardWeeks[0]}
                                onAddPunchToTimecardDay={this.addPunchToTimecardDay}
                                onTimeChange={this.onTimeChange}
                                onConfirmDelete={this.onConfirmDelete}
                                readonly={this.props.readonly}
                                hierarchyItemId={this.state.timecard.Equipment.DefaultHierarchyItemId}
                                openDailyHistoryDrawer={this.openDailyHistoryDrawer}
                                reloadTimecard={this.loadTimecard}
                            />
                        </div>
                    )
                }
            }
        }

        return (
            <div className="detail-tab EmployeeTimecard" >
                <EquipmentTimecardActionBar
                    onDateChange={newDate => {
                        AppStateStore.setProgressSnackbarContent("loading")
                        this.setState({ referenceDate: moment(newDate).format(), pendingReviewed: false }, () =>
                            this.loadTimecard()
                        )
                    }}
                />
                <div style={{ clear: "both" }} />
                {timecardUI}
                {this.state.openAddPunchDialog &&
                    <AddPunchDialogForEquipment
                        equipment={EquipmentStore.getSelectedEquipment()}
                        addPunch={this.addPunch}
                        onRequestClose={this.closeAddPunchDialog}
                        defaultHierarchyId={this.state.defaultAddPunchHierarchyId}
                        defaultShiftId={this.state.defaultShiftId}
                        defaultAddJobId={this.state.defaultAddJobId}
                        defaultAddPhaseId={this.state.defaultAddPhaseId}
                        defaultEmployeeId={this.state.defaultEmployeeId}
                        defaultPositionId={this.state.defaultAddPunchPositionId}
                        defaultPayClassId={this.state.defaultAddPayClassId}
                        defaultAddPunchPayTypeId={this.state.defaultAddPunchPayTypeId}
                        isPunchIn={this.state.isPunchIn}
                        open={this.state.openAddPunchDialog}
                        date={this.state.punchTimecardDay.LocalStartDayTime}
                        timecard={this.state.timecard}
                        pairedPunchId={this.state.pairedPunchId}
                    />
                }
                <TimecardDailyDrawer
                    dayNum={this.state.dailyDrawerDate}
                    imageS3Url={EquipmentStore.getSelectedEquipment().ImageS3Url}
                    timecard={this.state.timecard && this.state.timecard}
                    closeDailyDrawer={this.closeDailyHistoryDrawer}
                />
            </div >
        )
    }
}
